// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"PolicyStatusDetail__contentContainer","json":"PolicyStatusDetail__json","statusDetailsTable":"PolicyStatusDetail__statusDetailsTable"};